import { WizardSegmentedProgress } from './WizardSegmentedProgress';

/**
 * Progresso agrupado em fases (onboarding: Sobre ti · Vida financeira · Pronto).
 *
 * O `.pen` **não** tem master de fases: modela a fase como sufixo do contador do
 * `ds/wizard/step-indicator--segmented` («PASSO 2 DE 9 · SOBRE TI»). Este
 * componente mantém a lógica de fases e delega o visual nesse indicador.
 *
 * `phases`: [{ id, name, start, end }] com passos 1-indexed inclusivos.
 */
export function WizardPhasedProgress({ step, total, phases = [], className, showPercent = true }) {
  const clamped = Math.max(1, Math.min(step, total));
  const activeIndex = phases.findIndex((p) => clamped >= p.start && clamped <= p.end);
  const phase = phases[activeIndex >= 0 ? activeIndex : 0];

  return (
    <WizardSegmentedProgress
      step={clamped}
      total={total}
      showPercent={showPercent}
      phaseLabel={phase?.name}
      className={className}
    />
  );
}

export default WizardPhasedProgress;
